import React, { Component } from 'react';


class Display extends React.Component {

  render() {

    if (this.props.error){
      var displayVal = "ERR";
    } else{
      if (this.props.active){
        var displayVal = this.props.children;
        displayVal = (displayVal == 0) ? "--" : displayVal;

      } else{
        var displayVal = "";
      }
    }

    return (
    <div className="display">{displayVal}</div>
    );
  }
}
export default Display;


// WEBPACK FOOTER //
// ./src/Display.js